var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Default, showSymbol=True, showText=False"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0852 460.819L30 0H481.456L440.327 460.746L255.451 512L71.0852 460.819Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.728 472.824L405.116 431.408L440.263 37.6788H255.728V472.824Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.94 208.59H255.728V265.107H129.253L114.009 94.1969H255.728V150.715H175.775L180.94 208.59Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48 355.438L255.728 355.372V414.174L255.468 414.246L139.696 382.107L131.778 293.366H188.513L192.536 338.442L255.48 355.438Z",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.532 94.1969H397.11L392.049 150.715H255.532V94.1969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.532 265.107V208.59H386.907L385.528 223.766L371.396 382.107L255.532 414.219V355.419L318.567 338.406L325.128 265.107H255.532Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.a75d9f4f17f2d9a84e021a88766c910f.svg";
export { ForwardRef as ReactComponent };